export default __webpack_public_path__ + "static/media/message-read.3891befe.svg";